import { render, staticRenderFns } from "./subsidiary-ledger-transactions-modal.vue?vue&type=template&id=45af955c&scoped=true&"
import script from "./subsidiary-ledger-transactions-modal.vue?vue&type=script&lang=js&"
export * from "./subsidiary-ledger-transactions-modal.vue?vue&type=script&lang=js&"
import style0 from "./subsidiary-ledger-transactions-modal.vue?vue&type=style&index=0&id=45af955c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45af955c",
  null
  
)

export default component.exports